import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {fetchAllPromotions} from '../../app/thunk'
import {ConfigurationPromo} from '../../types/configurationPromo'

export const promotionSlice = createSlice({
    name: 'promotions',
    initialState: {
        allPromotions: [],
        allPromotionsLoaded: false,
    },
    reducers: {
        setPromotions(
            state: RootState,
            action: PayloadAction<ConfigurationPromo[]>
        ): void {
            state.allPromotions = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                fetchAllPromotions.fulfilled,
                (state: RootState, action) => {
                    state.allPromotions = action.payload
                    state.allPromotionsLoaded = true
                }
            )
            .addCase(
                fetchAllPromotions.rejected,
                (state: RootState, action) => {
                    if (!action.meta.aborted) {
                        state.allPromotionsLoaded = true
                    }
                }
            )
    },
})

export default promotionSlice.reducer
